import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { GlassCard } from '../components/GlassCard';
import { useUserStore } from '../store/userStore';
import { DOMAIN_QUESTIONS } from '../data/constants';
import { getDomainCheckins } from '../lib/api';

function formatAnswer(v) {
  if (Array.isArray(v)) return v.join(', ');
  if (typeof v === 'boolean') return v ? 'Yes' : 'No';
  return String(v);
}

export default function DomainHistory() {
  const navigate = useNavigate();
  const { domain } = useParams();
  const user = useUserStore((s) => s.user);
  const d = DOMAIN_QUESTIONS[domain] || DOMAIN_QUESTIONS.sleep;
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    if (!user?.id) return;
    getDomainCheckins(user.id, domain, 90)
      .then((e) => setEntries(e || []))
      .finally(() => setLoading(false));
  }, [user?.id, domain]);

  const qLabel = (id) => d.questions.find((q) => q.id === id)?.question || id;

  return (
    <div className="min-h-screen" style={{ background: 'var(--aura-bg)' }}>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 pt-6 pb-16">
        <div className="flex items-center gap-3 mb-6">
          <button onClick={() => navigate('/app')} className="grid place-items-center w-9 h-9 rounded-full bg-white border border-[var(--aura-line)]"><i className="fa-solid fa-arrow-left" /></button>
          <div className="grid place-items-center w-10 h-10 rounded-xl" style={{ background: d.bg, color: d.color }}><i className={`fa-solid ${d.icon}`} /></div>
          <div>
            <h1 className="font-display text-2xl">{d.title}</h1>
            <p className="text-xs text-[var(--aura-ink-soft)]">90-day check-in history</p>
          </div>
        </div>

        {loading ? (
          <GlassCard className="p-8 text-center text-[var(--aura-ink-soft)]"><i className="fa-solid fa-circle-notch fa-spin" /></GlassCard>
        ) : entries.length === 0 ? (
          <GlassCard className="p-10 text-center">
            <p className="text-[var(--aura-ink-soft)] mb-4">No check-ins yet for this domain.</p>
            <button onClick={() => navigate(`/questionnaire/${domain}`)} className="aura-btn-gradient text-white font-semibold rounded-full px-6 py-3">Start a check-in</button>
          </GlassCard>
        ) : (
          <div className="flex flex-col gap-3">
            {entries.map((e, i) => (
              <GlassCard key={e.id || i} className="overflow-hidden">
                <button onClick={() => setOpen(open === i ? null : i)} className="w-full flex items-center justify-between p-4 text-left">
                  <div>
                    <div className="font-semibold">{e.date}</div>
                    <div className="text-xs text-[var(--aura-ink-soft)]">{Object.keys(e.answers || {}).length} answers</div>
                  </div>
                  <i className={`fa-solid fa-chevron-${open === i ? 'up' : 'down'} text-[var(--aura-ink-soft)]`} />
                </button>
                {open === i && (
                  <div className="px-4 pb-4 border-t border-[var(--aura-line)] pt-3 space-y-3">
                    {Object.entries(e.answers || {}).map(([k, v]) => (
                      <div key={k}>
                        <div className="text-xs text-[var(--aura-ink-soft)]">{qLabel(k)}</div>
                        <div className="text-sm font-medium" style={{ color: d.color }}>{formatAnswer(v)}</div>
                      </div>
                    ))}
                  </div>
                )}
              </GlassCard>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
